"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _propTypes = require("prop-types");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseTranslation = require("nicbase-translation");

var _home = _interopRequireDefault(require("../home/home"));

var _logoMyBgl = _interopRequireDefault(require("./logo-myBgl.png"));

var _mapBgl = _interopRequireDefault(require("./map-bgl.png"));

var _nicplaceYou = _interopRequireDefault(require("./nicplaceYou.png"));

var _screenBgl = _interopRequireDefault(require("./screen-bgl.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    contentBoxes: state.home
  };
};

exports.mapStateToProps = mapStateToProps;

var HomeBGL = function HomeBGL(_ref) {
  var portalId = _ref.portalId,
      contentBoxes = _ref.contentBoxes;
  var showNewsBadge = contentBoxes.some(function (box) {
    return new Date(box.lastActivated) >= new Date(localStorage.getItem('newsCheckedAt'));
  });

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Tabs, {
    index: activeTab,
    onChange: function onChange(nextTabIndex) {
      setActiveTab(nextTabIndex);

      if (nextTabIndex === 1) {
        localStorage.setItem('newsCheckedAt', new Date().toISOString());
      }
    },
    className: "overflow-hidden flex-1",
    headersClassName: "shadow-lg z-1",
    contentClassName: "overflow-auto flex"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Tab, {
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "home.welcome"
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-primary px-8 m-6"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "home.bgl.welcome"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("h1", {
      className: "font-bold text-4xl"
    }, message);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "home.light.welcome.subheader"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("p", null, message);
  }), /*#__PURE__*/_react["default"].createElement("section", {
    className: "mt-8 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "rounded shadow flex  flex-col justify-between items-center p-5 bg-white"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "home.bgl.content.represent.title"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("h3", {
      className: "text-2xl font-bold text-center mb-8"
    }, message);
  }), /*#__PURE__*/_react["default"].createElement("img", {
    className: "h-32 w-auto object-scale-down",
    src: _screenBgl["default"],
    alt: ""
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-flex items-center mt-4 mb-10"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "home.bgl.content.represent.description"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: "text-center"
    }, message);
  })), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "/data-control-center/".concat(portalId, "/company-profile"),
    className: "mb-4 bg-primary p-2 rounded text-white uppercase font-bold hidden text-base lg:block"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "home.bgl.content.represent.cta"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "rounded shadow flex flex-col justify-between items-center p-5 bg-white"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "home.bgl.content.find.title"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("h3", {
      className: "text-2xl font-bold text-center"
    }, message);
  }), /*#__PURE__*/_react["default"].createElement("img", {
    className: "h-32 object-scale-down",
    src: _mapBgl["default"],
    alt: ""
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-flex items-center mb-8"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "home.bgl.content.find.description"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: "text-center"
    }, message);
  })), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "/data-control-center/".concat(portalId, "/bgl-connect"),
    className: "mb-4 bg-primary p-2 rounded text-white uppercase font-bold hidden text-base lg:block"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "home.bgl.content.find.cta"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "rounded shadow flex flex-col justify-between items-center p-5 bg-white"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "home.bgl.content.backUp.title"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("h3", {
      className: "text-2xl font-bold text-center"
    }, message);
  }), /*#__PURE__*/_react["default"].createElement("img", {
    className: "h-32 mb-6 mt-16 object-scale-down",
    src: _logoMyBgl["default"],
    alt: ""
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-flex items-center w-3/4"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "home.bgl.content.backUp.description"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: "text-center mb-6"
    }, message);
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "home.bgl.content.backUp.cta"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      className: "cursor-pointer mb-4 bg-primary p-2 rounded text-white font-bold hidden text-base lg:block",
      href: "https://www.mybgl.net",
      target: "_blank",
      rel: "noopener noreferrer"
    }, value);
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "md:col-span-2 rounded shadow p-5 px-10 bg-white flex flex-col md:flex-row md:items-center"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "h-24 object-scale-down mr-8",
    src: _nicplaceYou["default"],
    alt: ""
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "home.bgl.content.whyNICplace.content"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: "my-3"
    }, message);
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "md:col-start-2 md:row-start-2 lg:row-start-auto lg:col-start-auto rounded shadow p-5 bg-primary text-white flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-2/3 flex justify-center items-center"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold",
    style: {
      fontSize: '7.2rem'
    }
  }, "?")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-5"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "home.bgl.support.title"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("h3", null, message);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "home.bgl.support.content1"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: "mb-3"
    }, message);
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "home.bgl.support.content2"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      className: "underline text-white",
      href: "mailto:mybglconnect@nic-place.com"
    }, message);
  })))))), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Tab, {
    label: /*#__PURE__*/_react["default"].createElement("span", {
      className: "relative"
    }, showNewsBadge ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "absolute right-0 transform -translate-y-1/2 translate-x-1/2 px-1 bg-red-500 text-white text-xs rounded-full"
    }, "News") : null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "home.tab.nicplace"
    }))
  }, /*#__PURE__*/_react["default"].createElement(_home["default"], null)));
};

HomeBGL.propTypes = {
  portalId: _propTypes.PropTypes.number.isRequired,
  contentBoxes: _propTypes.PropTypes.arrayOf(_propTypes.PropTypes.shape({
    mediaUrl: _propTypes.PropTypes.string,
    mediaPosition: _propTypes.PropTypes.string,
    media: _propTypes.PropTypes.bool,
    text: _propTypes.PropTypes.oneOfType([_propTypes.PropTypes.shape({
      blocks: _propTypes.PropTypes.arrayOf(_propTypes.PropTypes.shape()).isRequired
    }), _propTypes.PropTypes.string]),
    category: _propTypes.PropTypes.string,
    id: _propTypes.PropTypes.number
  }))
};
HomeBGL.defaultProps = {
  contentBoxes: []
};

var _default = (0, _nicbaseTranslation.injectIntl)((0, _reactRedux.connect)(mapStateToProps, null)(HomeBGL));

exports["default"] = _default;